import { relations } from 'drizzle-orm';
import { foreignKey, index, integer, pgTable, serial, text, timestamp, uniqueIndex } from 'drizzle-orm/pg-core';
import { application } from './application';
import { organization } from './organization';

export const hostedAuthDomain = pgTable(
  'hosted_auth_domain',
  {
    id: serial().primaryKey(),
    organization_id: integer()
      .notNull()
      .references(() => organization.id, { onDelete: 'cascade' }),
    domain: text().notNull(),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
  },
  (t) => [
    uniqueIndex('hosted_auth_domain_domain_uq').on(t.domain),
    uniqueIndex('hosted_auth_domain_id_organization_id_uq').on(t.id, t.organization_id),
    index('hosted_auth_domain_organization_id_idx').on(t.organization_id),
  ],
);

export const hostedAuthDomainRelations = relations(hostedAuthDomain, ({ many, one }) => ({
  organization: one(organization, {
    fields: [hostedAuthDomain.organization_id],
    references: [organization.id],
  }),
  applications: many(hostedAuthApplicationDomain),
}));

export type HostedAuthDomain = typeof hostedAuthDomain.$inferSelect;
export type InsertHostedAuthDomain = typeof hostedAuthDomain.$inferInsert;

export const hostedAuthApplicationDomain = pgTable(
  'hosted_auth_application_domain',
  {
    id: serial().primaryKey(),
    hosted_auth_domain_id: integer().notNull(),
    application_id: integer().notNull(),
    organization_id: integer()
      .notNull()
      .references(() => organization.id, { onDelete: 'cascade' }),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
  },
  (t) => [
    uniqueIndex('hosted_auth_application_domain_domain_application_uq').on(t.hosted_auth_domain_id, t.application_id),
    index('hosted_auth_application_domain_application_id_idx').on(t.application_id),
    index('hosted_auth_application_domain_domain_id_idx').on(t.hosted_auth_domain_id),
    foreignKey({
      columns: [t.application_id, t.organization_id],
      foreignColumns: [application.id, application.organization_id],
      name: 'hosted_auth_application_domain_application_organization_fk',
    }).onDelete('cascade'),
    foreignKey({
      columns: [t.hosted_auth_domain_id, t.organization_id],
      foreignColumns: [hostedAuthDomain.id, hostedAuthDomain.organization_id],
      name: 'hosted_auth_application_domain_domain_organization_fk',
    }).onDelete('cascade'),
  ],
);

export const hostedAuthApplicationDomainRelations = relations(hostedAuthApplicationDomain, ({ one }) => ({
  hostedAuthDomain: one(hostedAuthDomain, {
    fields: [hostedAuthApplicationDomain.hosted_auth_domain_id],
    references: [hostedAuthDomain.id],
  }),
  application: one(application, {
    fields: [hostedAuthApplicationDomain.application_id],
    references: [application.id],
  }),
}));

export type HostedAuthApplicationDomain = typeof hostedAuthApplicationDomain.$inferSelect;
export type InsertHostedAuthApplicationDomain = typeof hostedAuthApplicationDomain.$inferInsert;
